<!-- CurrencyInput.svelte -->
<script>
  export let value = 0;
  export let placeholder = "0";
  export let min = undefined;
  export let max = undefined;
  // Default step values for each range
  export let stepSmall = 100;      // For values < 1000
  export let stepMedium = 1000;    // For values 1000-999999
  export let stepLarge = 100000;   // For values >= 1000000
  export let label = "";
  export let error = "";
  
  let displayValue;
  let suffix;
  let isFocused = false;
  
  // Determine current step based on value
  $: currentStep = value >= 1000000 ? stepLarge : 
                   value >= 1000 ? stepMedium : 
                   stepSmall;
  
  // Compute displayed value and suffix
  $: {
    if (isFocused) {
      displayValue = value.toLocaleString('sv-SE').replace(/,/g, ' ');
      suffix = 'kr';
    } else {
      if (value >= 1000000) {
        displayValue = (value / 1000000).toFixed(2).toLocaleString('sv-SE').replace('.', ',');
        suffix = 'mkr';
      } else if (value >= 1000) {
        displayValue = (value / 1000).toFixed(0).toLocaleString('sv-SE').replace('.', ',');
        suffix = 'tkr';
      } else {
        displayValue = value.toLocaleString('sv-SE').replace(/,/g, ' ');
        suffix = 'kr';
      }
    }
  }
  
  function handleInput(e) {
    const rawValue = e.target.value.replace(/[^\d.,]/g, '');
    // When focused, we're always working with kr
    let newValue = parseFloat(rawValue.replace(',', '.')) || 0;
    updateValue(newValue);
  }
  
  function handleFocus() {
    isFocused = true;
  }
  
  function handleBlur() {
    isFocused = false;
  }
  
  function updateValue(newValue) {
    if (min !== undefined) {
      newValue = Math.max(min, newValue);
    }
    if (max !== undefined) {
      newValue = Math.min(max, newValue);
    }
    value = Math.round(newValue);
  }
  
  function increment() {
    updateValue(value + currentStep);
  }
  
  function decrement() {
    updateValue(value - currentStep);
  }
</script>

<div class="input-container">
  {#if label}
    <label>{label}</label>
  {/if}
  
  <div class="input-wrapper" class:focused={isFocused}>
    <button 
      class="step-button left" 
      on:click={decrement}
      disabled={min !== undefined && value <= min}
      type="button"
    >
      -
    </button>
    
    <div class="input-field">
      <input 
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        value={displayValue}
        on:input={handleInput}
        on:focus={handleFocus}
        on:blur={handleBlur}
        {placeholder}
      />
      <span class="currency-suffix">{suffix}</span>
    </div>
    
    <button 
      class="step-button right"
      on:click={increment}
      disabled={max !== undefined && value >= max}
      type="button"
    >
      +
    </button>
  </div>
  
  {#if error}
    <span class="error">{error}</span>
  {/if}
</div>

<style>

  label {
    line-height: 0;
  }

  .input-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
/*     border: 1px solid blue; */
    width: 100%;
  }
  
  .input-wrapper {
    display: flex;
    align-items: center;
/*     border: 1px solid red; */
    padding-left: 10pt;
    gap: 0em;
    transition: all 0.3s ease-in-out;
    position: relative;
    z-index: 1;
  }
  
  .input-field {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
  }
  
  input {
    width: 100%;
    padding-right: 2.8rem; /* Make room for the kr suffix */
    text-align: right;
    background: #1e90ff;
    border: 2pt solid white;
    color: white;
    border-radius: 0;
    transition: all 0.1s ease-in-out;
  }

  .input-wrapper.focused input {
      padding-right: 1.8rem;
      border-radius: 30pt;
  }


  .input-wrapper.focused button.step-button {
    display: none;
  }
  
  .currency-suffix {
    position: absolute;
    top: 10px;
    right: 0.5rem;
    font-weight: 400;
    color: white;
    user-select: none;
    pointer-events: none;
  }
  
  .step-button {
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #1e90ff;
    border: 2pt solid white;
    color: white;
    cursor: pointer;
    transition: all 0.1s ease-in-out;
  }

  .step-button.left {
    border-radius: 50px 0 0 50px;
    border-right: 0;
  }
  
  .step-button.right {
    border-radius: 0 50px 50px 0;
    border-left: 0;
  }

  .step-button:hover:not(:disabled) {
    background: white;
    color: #1e90ff;
  }
  
  .step-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  .error {
    color: red;
    font-size: 0.875rem;
  }

  /* Mobile styles */
  @media (max-width: 768px) {
    .input-wrapper {
      font-size: 10pt;
    }

    input {
      padding-right: 2.1rem;
    }

    .currency-suffix {
      top: 6pt;
    }

    .step-button {
      width: 25px;
    }

    .input-wrapper.focused {
      position: relative;
/*       transform: scale(1.2); */
/*       font-size: 8pt; */
      z-index: 2;
    }

    .input-wrapper.focused input {
      padding-right: 1.4rem;
      border-radius: 15pt;
    }

    .input-wrapper.focused button.step-button {
      display: none;
    }

    .input-wrapper.focused .currency-suffix {
/*       top: 5pt; */
    }
    /* Optional: Add some spacing when focused to prevent overlap */
/*     .input-container {
      margin: 1rem 0;
    } */
  }

</style>